// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicDesktopV1FiltersGetMetaRequest,
  TPublicDesktopV1FiltersGetMetaModel,
  IMappers,
  TPublicDesktopV1FiltersGetMetaResponse,
  IPublicDesktopV1FiltersGetMetaResponse,
  IPublicDesktopV1FiltersGetMetaResponseError,
} from './types';

export const defaultConfig: TPublicDesktopV1FiltersGetMetaModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'commercial-search-offers',
  pathApi: '/desktop/v1/filters/get-meta/',
  requestType: 'json',
} as TPublicDesktopV1FiltersGetMetaModel;

export function createPublicDesktopV1FiltersGetMetaModel(
  parameters: IPublicDesktopV1FiltersGetMetaRequest,
): TPublicDesktopV1FiltersGetMetaModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicDesktopV1FiltersGetMetaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicDesktopV1FiltersGetMetaRequest;
}

export async function fetchPublicDesktopV1FiltersGetMeta<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicDesktopV1FiltersGetMetaOptions<TResponse200, TResponse400>): Promise<
  TPublicDesktopV1FiltersGetMetaResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicDesktopV1FiltersGetMetaModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicDesktopV1FiltersGetMetaResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicDesktopV1FiltersGetMetaResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicDesktopV1FiltersGetMetaResponse;
}
